import React, { useState, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { uploadExcel } from '../../redux/digitalPriceSlice';
import Button from '../../components/button';
import CustomMultiSelect from '../../components/customMultiSelect/CustomMultiSelect';
import CustomInput from '../../components/customInput/CustomInput';
import SubmitConfirmationModal from './SubmitConfirmationModal';
import CommonSuccessModal from '../../components/commonSuccessModal/CommonSuccessModal';
import 'bootstrap/dist/css/bootstrap.min.css';
import './SubmitConfirmationModal.css';
import { UPLOAD_EXCEL_SUCCESS } from '../../utils/constant';

function ExcelSelectedShopUpload({
  onBackClick,
  singtelOptions = [],
  shopOptions = []
}) {
  const dispatch = useDispatch();
  const [selectedSingtelShops, setSelectedSingtelShops] = useState([]);
  const [selectedSerShops, setSelectedSerShops] = useState([]);
  const [uploadFile, setUploadFile] = useState('');
  const [showShopError, setShowShopError] = useState(false);
  const [showFileError, setShowFileError] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const fileInputRef = useRef(null);
  const [isFileSelected, setIsFileSelected] = useState(false);
  const [isUploading, setIsUploading] = useState(false);

  const [successModalConfig, setSuccessModalConfig] = useState({
    show: false,
    message: '',
    status: false,
    onClose: () => { }
  });

  const buildDiscExcelShops = () => {
    const singtelItems = selectedSingtelShops.map(shopId => ({
      shopId,
      shopCategory: "SINGTEL"
    }));

    const serItems = selectedSerShops.map(shopId => ({
      shopId,
      shopCategory: "PARTNER"
    }));

    return [...singtelItems, ...serItems];
  };

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (file) {
      setUploadFile(file.name);
      setShowFileError(false);
      setIsFileSelected(true);
    } else {
      setUploadFile('');
      setIsFileSelected(false);
    }
  };

  const handleSubmit = () => {
    const hasShopSelected = selectedSingtelShops.length > 0 || selectedSerShops.length > 0;
    setShowShopError(!hasShopSelected);

    const hasFileSelected = uploadFile.trim() !== '';
    setShowFileError(!hasFileSelected);

    if (!hasShopSelected || !hasFileSelected) {
      return;
    }

    setShowConfirmationModal(true);
  };

  const handleConfirmSubmit = () => {
    setShowConfirmationModal(false);
    setIsUploading(true);

    const fileElement = fileInputRef.current;
    const file = fileElement.files[0];

    const uploadParams = {
      file,
      discountType: 3,
      disc_excel_shops: buildDiscExcelShops()
    };

    dispatch(uploadExcel(uploadParams))
      .unwrap()
      .then(() => {
        setSuccessModalConfig({
          show: true,
          message: UPLOAD_EXCEL_SUCCESS,
          status: true,
          onClose: () => {
            resetForm();
            onBackClick();
          }
        });
      })
      .catch((error) => {
        setSuccessModalConfig({
          show: true,
          message: error.message,
          status: false,
          onClose: resetForm
        });
      })
      .finally(() => {
        setIsUploading(false);
      });
  };

  const resetForm = () => {
    setSelectedSingtelShops([]);
    setSelectedSerShops([]);
    setUploadFile('');
    setShowShopError(false);
    setShowFileError(false);
    setIsFileSelected(false);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const handleCloseSuccessModal = () => {
    setSuccessModalConfig(prev => ({
      ...prev,
      show: false
    }));
  };

  return (
    <div className="manage-user-container">
      <div style={{ padding: '30px' }}>
        <div>Upload Excel (Selected Shop)</div>

        <div style={{ marginTop: '30px', marginBottom: '30px' }}>Select type of shop </div>

        <div style={{ marginBottom: '40px' }}>
          <div style={{ display: 'flex', gap: '20px', marginBottom: '10px' }}>
            <div style={{ flex: 1 }}>
              <div style={{ marginBottom: '10px' }}>Singtel</div>
              <CustomMultiSelect
                options={singtelOptions}
                placeholder="Select Singtel shop(s)"
                selectedValues={selectedSingtelShops}
                onChange={(values) => {
                  setSelectedSingtelShops(values);
                  setShowShopError(false);
                }}
                style={{ width: '300px' }}
              />
            </div>

            <div style={{ flex: 1 }}>
              <div style={{ marginBottom: '10px' }}>SER Shop</div>
              <CustomMultiSelect
                options={shopOptions}
                placeholder="Select SER shop(s)"
                selectedValues={selectedSerShops}
                onChange={(values) => {
                  setSelectedSerShops(values);
                  setShowShopError(false);
                }}
                style={{ width: '300px' }}
              />
            </div>
          </div>
          {showShopError && (
            <div style={{ color: '#ED1A3D' }}>
              Please select at least 1 shop to apply the discount
            </div>
          )}
        </div>

        <div style={{ marginBottom: '10px' }}>Upload Discounted RRP Excel</div>

        <div style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
          <div className="file-input-container relative">
            <CustomInput
              type="text"
              value={uploadFile}
              disabled
              onChange={() => { }}
              style={{ width: '300px', height: '45px' }}
            />
            <span className="custom-placeholder" style={{
              position: 'absolute',
              left: '10px',
              top: '50%',
              transform: 'translateY(-50%)',
              color: '#aaa',
              pointerEvents: 'none',
              display: uploadFile ? 'none' : 'block'
            }}>
              Select a file to upload
            </span>
          </div>

          <Button
            className='upload-btn'
            style={{ marginLeft: '20px' }}
            onClick={() => fileInputRef.current.click()}
          >
            BROWSE
          </Button>

          <input
            type="file"
            id="fileInput"
            accept=".xlsx, .xls"
            style={{ display: 'none' }}
            ref={fileInputRef}
            onChange={handleFileSelect}
          />
        </div>

        {showFileError && (
          <div style={{ color: '#ED1A3D', marginBottom: '20px' }}>Please upload file</div>
        )}

        <div style={{ marginBottom: '20px', fontSize: '14px' }}>
          Note: Maximum upload file size is 4 GB
        </div>

        <div style={{
          position: 'fixed',
          bottom: '50px',
          right: '50px',
          display: 'flex',
          gap: '20px'
        }}>
          <Button
            className='upload-btn'
            onClick={handleSubmit}
            disabled={isUploading}
          >
            {isUploading ? 'Uploading...' : 'SUBMIT'}
          </Button>
          <Button className='upload-btn' onClick={onBackClick}>CANCEL</Button>
        </div>
      </div>

      <SubmitConfirmationModal
        show={showConfirmationModal}
        selectedSingtelShops={selectedSingtelShops.map(value => {
          const shop = singtelOptions.find(option => option.value === value);
          return shop || null;
        }).filter(Boolean)}
        selectedSerShops={selectedSerShops.map(value => {
          const shop = shopOptions.find(option => option.value === value);
          return shop || null;
        }).filter(Boolean)}
        onConfirm={handleConfirmSubmit}
        onCancel={() => setShowConfirmationModal(false)}
      />

      <CommonSuccessModal
        showModal={successModalConfig.show}
        handleClose={() => {
          handleCloseSuccessModal();
          successModalConfig.onClose();
        }}
        message={successModalConfig.message}
        status={successModalConfig.status}
      />
    </div>
  );
}

export default ExcelSelectedShopUpload;